import React from 'react';
import { Link, Outlet } from 'react-router-dom';
import Container from '@mui/material/Container';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';


import { useUserInfo } from './kratos/common';
import Waiting from './Waiting';
import MainRouter from './MainRouter';
import Logout from './Logout';


export default function IdentityPortal() {
  const { userType, displayName, query } = useUserInfo();
  const isAuthenticated = userType === 'authenticated';

  function innerUi() {
    if (query.isLoading) {
      return <Waiting message="Checking session..." />;
    }

    if (query.isError || !query.isSuccess) {
      return (
        <Alert severity="error">
          Failed to get session!
        </Alert>);
    }

    return (
      isAuthenticated
      ? loggedInUi(displayName)
      : loggedOutUi()
    );
  }

  return <>
    <Container maxWidth={isAuthenticated ? 'md' : 'xs'}>
      <Paper elevation={20}>
        <Container>
          {innerUi()}
        </Container>
      </Paper>
    </Container>
  </>;
}

function loggedInUi(displayName: string) {
  // TODO: add verification Link once implemented..
  return <Stack spacing={2}>
    <div></div>

    <div>
      <Logout/>
      <Button component={Link} to="settings" variant="outlined">
        Settings
      </Button>
    </div>

    <Typography variant="h6">Welcome {displayName}!</Typography>

    <Outlet />
    <MainRouter />
    <div></div>
  </Stack>;
}


function loggedOutUi() {
  return <Stack spacing={2}>
    <div></div>
    <Outlet />
    <MainRouter />
    <div></div>
  </Stack>;
}
